var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .333h14c5.333 0 9.666 4.334 9.666 9.667v14A9.667 9.667 0 0124 33.667H10C4.666 33.667.333 29.333.333 24V10A9.667 9.667 0 019.999.333zm-.334 3.334a6 6 0 00-6 6v14.667c0 3.316 2.683 6 6 6h14.667a6 6 0 006-6V9.667c0-3.317-2.684-6-6-6H9.666zm16.083 2.5a2.083 2.083 0 110 4.167 2.083 2.083 0 010-4.167zM17 8.667a8.333 8.333 0 110 16.666 8.333 8.333 0 010-16.666zM17 12a5 5 0 100 10 5 5 0 000-10z",
    fill: "#fff"
  })));
}
export default SvgInstagramWhite;